<form (ngSubmit)="submit()" novalidate [formGroup]="form" autocomplete="off">
  <ion-list>
    <ion-item>
      <ion-label position="floating">
        {{ 'Checkout.Form.FirstName' | translate }}<span style="color:red;">*</span>
      </ion-label>
      <ion-input autocompleteOff (ionChange)="submit()" formControlName="firstname" type="text"></ion-input>
      <!--<span *ngIf="formErrors.has('firstName')" color="danger"><br />{{formErrors.get('firstName')}}</span>-->
      @if (formFieldValidatorSubmit('firstname', 'required')) {
        <span class="form-errors"
        >{{ 'Checkout.FormErrors.FirstNameRequired' | translate}}</span>
      }
    </ion-item>
    <ion-item>
      <ion-label position="floating">
        {{ 'Checkout.Form.LastName' | translate }}<span style="color:red;">*</span>
      </ion-label>
      <ion-input autocompleteOff (ionChange)="submit()" formControlName="lastname" type="text"></ion-input>
      <!--<span *ngIf="formErrors.has('lastName')" color="danger"><br />{{formErrors.get('lastName')}}</span>-->
      @if (formFieldValidatorSubmit('lastname', 'required')) {
        <span class="form-errors"
        >{{ 'Checkout.FormErrors.LastNameRequired' | translate}}</span>
      }
    </ion-item>
    <ion-item>
      <ion-label position="floating">
        {{ 'Checkout.Form.Email' | translate }}<span style="color:red;">*</span>
      </ion-label>
      <ion-input autocompleteOff (ionChange)="submit()" formControlName="email" type="text"></ion-input>
      <!--<span *ngIf="formErrors.has('email')" color="danger"><br />{{formErrors.get('email')}}</span>-->
      @if (formFieldValidatorSubmit('email', 'email')) {
        <span class="form-errors"
        >{{'Checkout.FormErrors.EmailInvalid' | translate}}</span>
      }
      @if (formFieldValidatorSubmit('email', 'required')) {
        <span class="form-errors"
        >{{'Checkout.FormErrors.EmailRequired' | translate}}</span>
      }
    </ion-item>
    <ion-item>
      <ion-label position="floating">
        {{ 'Checkout.Form.PhoneNumber' | translate }}<span style="color:red;">*</span>
      </ion-label>
      <ion-input autocompleteOff (ionChange)="submit()" formControlName="phone" type="text"></ion-input>
      <!--<span *ngIf="formErrors.has('phone')" color="danger"><br />{{formErrors.get('phone')}}</span>-->
      @if (formFieldValidatorSubmit('phone', 'required')) {
        <span class="form-errors"
        >{{'Checkout.FormErrors.PhoneNumberRequired' | translate}}</span>
      }
    </ion-item>
  </ion-list>
</form>